import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isNil } from 'lodash';
import { ApexChart, ApexDataLabels, ApexLegend, ApexPlotOptions, ApexStroke, ApexTooltip, NgApexchartsModule } from 'ng-apexcharts';

@Component({
  selector: 'la-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrl: './donut-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgApexchartsModule],
})
export class DonutChartComponent {
  @Input() series: number[] = [];
  @Input() labels: string[] = [];
  @Input() colors: string[] = [];

  options: {
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    legend: ApexLegend;
    tooltip: ApexTooltip;
    stroke: ApexStroke;
  } = {
    chart: {
      type: 'donut',
      height: '250px',
    },
    dataLabels: { enabled: false },
    legend: {
      show: false,
    },
    stroke: { width: 0 },
    tooltip: {
      enabled: true,
      y: {
        formatter: (v) => this.getPercentage(v),
      },
    },
  };

  get seriesForChart() {
    return this.series.map((value) => (isNil(value) ? 0 : value));
  }

  get maxValueIndex() {
    return this.findMaxIndex(this.series);
  }

  get innerLabel() {
    const maxValue = this.series?.length && this.series[this.maxValueIndex];
    return isNil(maxValue) ? 'N/A' : this.getPercentage(maxValue);
  }

  get innerValue() {
    return this.labels[this.maxValueIndex]?.toString();
  }

  get plotOptions(): ApexPlotOptions {
    return {
      pie: {
        expandOnClick: false,
        donut: {
          size: '85%',
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              label: this.innerLabel,
              fontSize: '20px',
              formatter: () => this.innerValue,
            },
            value: {
              fontSize: '12px',
              offsetY: -2,
            },
          },
        },
      },
    };
  }

  private getPercentage(value: number) {
    const sum = this.series?.reduce((sum, current) => sum + current, 0);
    const result = (sum > 0 ? value / sum : 0) * 100;
    return (Number.isInteger(result) ? result : result.toFixed(2)) + '%';
  }

  private findMaxIndex(arr: number[]) {
    let maxIndex = 0;

    for (let i = 1; i < arr.length; i++) {
      if (arr[i] > arr[maxIndex]) {
        maxIndex = i;
      }
    }

    return maxIndex;
  }
}
